const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initTrustStrip(root = document) {
  root.querySelectorAll('[data-ev-trust]').forEach((strip) => {
    if (strip.dataset.evReady === 'true') return;
    strip.dataset.evReady = 'true';

    const button = strip.querySelector('[data-ev-trust-toggle]');
    if (!button || reducedMotion) return;

    button.addEventListener('click', () => {
      const paused = strip.classList.toggle('is-paused');
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    });
  });
}

function initReveals(root = document) {
  const items = [...root.querySelectorAll('[data-ev-reveal]:not([data-ev-observed])')];
  if (!items.length) return;

  items.forEach((item) => item.setAttribute('data-ev-observed', 'true'));

  if (reducedMotion || !('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  items.forEach((item) => observer.observe(item));
}

function initEvanira(root = document) {
  if (!reducedMotion) document.documentElement.classList.add('ev-motion-ready');
  initTrustStrip(root);
  initReveals(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initEvanira(), { once: true });
} else {
  initEvanira();
}

document.addEventListener('shopify:section:load', (event) => initEvanira(event.target));
